export function formatTime(value) {
  if (
    Object.prototype.toString.call(value) === "[object Date]" &&
    !isNaN(value.getTime())
  ) {
    return value.toISOString().split("T")[0];
  }
  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    return date.toISOString().split("T")[0];
  } else {
    return null;
  }
}

export function isValidDate(dateString) {
  const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(dateString);

  if (!isValidFormat) {
    return false;
  }

  const date = new Date(dateString);
  const isValid = !isNaN(date.getTime());

  return isValid;
}

export function validateCardNumber(digit) {
  const numericRegex = /^[0-9]+$/;
  const digitLength = digit.length;

  if (!numericRegex.test(digit)) {
    return false;
  }

  if (digitLength >= 14 && digitLength <= 16) {
    return true;
  }

  return false;
}

export function validateCVC(digit) {
  const numericRegex = /^[0-9]+$/;
  const digitLength = digit.length;

  if (!numericRegex.test(digit)) {
    return false;
  }

  if (digitLength >= 3 && digitLength <= 4) {
    return true;
  }

  return false;
}

export function calculateTimeAgo(specifiedDate) {
  const currentTime = new Date();
  const specifiedTime = new Date(specifiedDate);
  const timeDifference = currentTime - specifiedTime;

  const millisecondsInAYear = 1000 * 60 * 60 * 24 * 365.25;
  const millisecondsInAMonth = millisecondsInAYear / 12;
  const millisecondsInADay = 1000 * 60 * 60 * 24;
  const millisecondsInAnHour = 1000 * 60 * 60;
  const millisecondsInAMinute = 1000 * 60;
  const millisecondsInASecond = 1000;

  if (timeDifference >= millisecondsInAYear) {
    const yearsAgo = Math.floor(timeDifference / millisecondsInAYear);
    return yearsAgo === 1 ? "1 year ago" : `${yearsAgo} years ago`;
  } else if (timeDifference >= millisecondsInAMonth) {
    const monthsAgo = Math.floor(timeDifference / millisecondsInAMonth);
    return monthsAgo === 1 ? "1 month ago" : `${monthsAgo} months ago`;
  } else if (timeDifference >= millisecondsInADay) {
    const daysAgo = Math.floor(timeDifference / millisecondsInADay);
    return daysAgo === 1 ? "1 day ago" : `${daysAgo} days ago`;
  } else if (timeDifference >= millisecondsInAnHour) {
    const hoursAgo = Math.floor(timeDifference / millisecondsInAnHour);
    return hoursAgo === 1 ? "1 hour ago" : `${hoursAgo} hours ago`;
  } else if (timeDifference >= millisecondsInAMinute) {
    const minutesAgo = Math.floor(timeDifference / millisecondsInAMinute);
    return minutesAgo === 1 ? "1 minute ago" : `${minutesAgo} minutes ago`;
  } else {
    const secondsAgo = Math.floor(timeDifference / millisecondsInASecond);
    return secondsAgo === 1 ? "1 second ago" : `${secondsAgo} seconds ago`;
  }
}

export function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}